import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#070B14] text-white flex items-center justify-center p-8" data-testid="payment-cancel">
      <div className="max-w-lg w-full bg-[#0D1424] border border-white/10 p-10 text-center">
        <XCircle className="w-14 h-14 text-slate-400 mx-auto mb-6" strokeWidth={1.5} />
        <div className="mono-label text-slate-400 mb-3">// CHECKOUT CANCELLED</div>
        <h1 className="font-display font-black text-3xl mb-3 tracking-tight">No worries.</h1>
        <p className="text-slate-400 mb-8">Your card was not charged. Come back whenever you're ready.</p>
        <div className="flex gap-3 justify-center">
          <Link to="/pricing" className="bg-cyan-400 text-[#070B14] px-6 py-3 mono-label hover:bg-cyan-300" data-testid="back-to-pricing">BACK TO PRICING</Link>
          <Link to="/dashboard" className="border border-white/20 hover:border-cyan-400 px-6 py-3 mono-label">DASHBOARD</Link>
        </div>
      </div>
    </div>
  );
}
